import * as React from "react";
const SvgPoOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M12 5v2H5v12.22h12V12h2v7c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2zm3 12H7v-2h8zm0-5v2H7v-2zm0-1H7V9h8zm4-9v3h3v2h-3v2.99c-.002 0-1.982.01-2 0V7h-3s.01-1.99 0-2h3V2z"
    />
  </svg>
);
export default SvgPoOutlined;
